import { FieldValues, UseFormGetValues } from "react-hook-form";
import { AbstractValidation } from "./AbstractValidation";

export abstract class AbstractCrossFieldValidation extends AbstractValidation {
  protected getValues: UseFormGetValues<FieldValues>;
  protected basePath: string;

  setGetValues = (getValues: UseFormGetValues<FieldValues>): void => {
    this.getValues = getValues;
  };

  setBasePath = (basePath: string): void => {
    this.basePath = basePath;
  };
}
